<template>
    <div class="cz2__calendar">
        <div class="cz2__calendar-wrapper">
            <div class="cz2__calendar-image" />

            <div class="cz2__calendar-info-wrapper">
                <h2 class="cz2__calendar-title">
                    <img
                        v-if="calendarInCart"
                        src="../assets/icons/check-black.svg"
                        width="16"
                        height="12"
                        aria-hidden="true"
                    >
                    {{ calendarTitleCopy }}
                </h2>

                <p class="cz2__calendar-copy">
                    {{ $t('CALENDAR_CARD_COPY') }}
                </p>

                <div
                    v-if="isKiosk"
                    class="cz2__calendar-buttons"
                >
                    <calendar-add-remove-button :is-card="true" />

                    <btn
                        :secondary="!calendarInCart"
                        @click="showInfoModal"
                    >
                        {{ $t('CALENDAR_DETAILS') }}
                    </btn>
                </div>
            </div>
        </div>

        <div
            v-if="!isKiosk"
            class="cz2__calendar-buttons"
        >
            <calendar-add-remove-button :is-card="true" />

            <btn
                :secondary="!calendarInCart"
                @click="showInfoModal"
            >
                {{ $t('CALENDAR_DETAILS') }}
            </btn>
        </div>
    </div>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__calendar {
            margin-bottom: 16px;
            border-radius: 16px;
            padding: 16px;
            display: flex;
            flex-direction: column;
            background-color: color(v2BlueLight);
            font-family: 'Proxima Nova', sans-serif;
            color: black;

            .cz2__calendar-wrapper {
                width: 100%;
                display: flex;
                flex-direction: column;

                .cz2__calendar-image {
                    width: 100%;
                    height: 235px;
                    background-image: url(../assets/images/branded/holiday/holiday-calendar-placeholder.webp);
                    background-size: contain;
                    background-repeat: no-repeat;
                    background-position: center;
                }
            }

            .cz2__calendar-info-wrapper {
                width: 100%;
            }

            .cz2__calendar-title {
                margin-bottom: 8px;
                font-size: 20px;
                font-weight: 800;
            }

            .cz2__calendar-copy {
                margin-bottom: 12px;
                font-size: 15px;
            }

            .cz2__calendar-buttons {
                margin-top: 16px;
                width: 100%;
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                gap: 8px;
            }

            .cz2__btn,
            .cz2__calendar-add-remove-button {
                flex-grow: 1;
                height: 40px;

                &:hover {
                    font-size: 16px;
                }
            }

            .cz2__btn--secondary {
                background-color: white;
            }

            @include respond-above(sm) {
                padding: 24px;
            }

            @include respond-above(md) {
                .cz2__calendar-wrapper {
                    flex-direction: row;

                    .cz2__calendar-image {
                        width: 45%;
                        height: auto;
                    }

                    .cz2__calendar-info-wrapper {
                        width: 55%;
                    }
                }
            }
        }
    }

    #cz2.cz2.cz2__is-kiosk {
        .cz2__calendar {
            margin-bottom: 16px;
            border-radius: 16px;
            padding: 16px;
            display: flex;
            flex-direction: row;

            .cz2__calendar-wrapper {
                .cz2__calendar-image {
                    width: 40%;
                    height: 235px;
                    background-image: url(../assets/images/branded/pokemon/buddy-pack-placeholder.png);
                    background-size: contain;
                    background-repeat: no-repeat;
                    background-position: center;
                }

                .cz2__calendar-info-wrapper {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                }
            }

            .cz2__calendar-buttons {
                margin-top: 16px;
                width: 100%;
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                gap: 8px;

                .cz2__btn:hover {
                    font-size: 22px;
                }
            }
        }
    }
</style>

<script>
    import CalendarAddRemoveButton from './CalendarAddRemoveButton.vue';
    import Btn from './ui/Btn.vue';

    export default {
        components: {
            CalendarAddRemoveButton,
            Btn,
        },

        data() {
            return {
            };
        },

        computed: {
            calendarInCart() {
                return this.$store.getters.holidayCalendarInCart;
            },

            calendarTitleCopy() {
                return this.calendarInCart ? this.$t('CALENDAR_TITLE_ADDED') : this.$t('CALENDAR_TITLE');
            },

            isKiosk() {
                return this.$store.state.customizer.options.isKiosk;
            },
        },

        methods: {
            showInfoModal() {
                this.$store.dispatch('setShowCalendarModal', true);
            },
        },
    };
</script>
